module.exports = __webpack_public_path__ + "img/h1.491ac1a4.jpg";